import { Tile } from '@mc/design-system'
import styles from '../GlobalCarousel.module.scss'

export const TileSkeleton = () => (
  <div className='col'>
    <Tile aspectRatio='9x16' className='mc-corners--sm mc-overflow--hidden'>
      <div className={styles.shimmer} />
    </Tile>
  </div>
)
